import { render, staticRenderFns } from "./CCMLabsEdit.vue?vue&type=template&id=4d8fbc96"
import script from "./CCMLabsEdit.vue?vue&type=script&lang=js"
export * from "./CCMLabsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports